export default function Dot({ width = 1 }: { width?: number }) {
	return (
		<svg
			viewBox={`0 0 ${2 * width} ${2 * width}`}
			className="mx-2 inline fill-current"
			style={{
				width: `${2 * width}px`,
				height: `${2 * width}px`,
			}}
		>
			<circle r={width} cx={width} cy={width} />
		</svg>
	)
}
